import ToggleableSection from 'components/ToggleableSection'
import LegalSexSelector from './LegalSexSelector'

export const LegalSexSection = () => {
  return (
    <ToggleableSection title="Legal Sex">
      <LegalSexSelector />
    </ToggleableSection>
  )
}
